import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import {
  ChecklistBasicInfo,
  ChecklistDetail
} from "@shared/models/car-workshop-checklist-dto";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class CarWorkshopChecklistService {
  constructor(private http: HttpClient) {}

  getChecklistInfoByFleetId(fleetId: number): Observable<ChecklistBasicInfo[]> {
    return this.http.get<ChecklistBasicInfo[]>(
      `${environment.microserviceCarWorkshopChecklistApiUrl}data/basic-info/${fleetId}`
    );
  }

  getChecklistAnswersByChecklistId(
    checklistId: string
  ): Observable<ChecklistDetail> {
    return this.http.get<ChecklistDetail>(
      `${environment.microserviceCarWorkshopChecklistApiUrl}data/answers/${checklistId}`
    );
  }
}
